export const transformPixelsToMediaQueryEm = (x: number) => `${x / 16}em`;
